// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewUsersPopupView__container-b4698b {
  height: 100%;
  overflow-y: auto;
  margin-bottom: 10px;
  margin-top: 20px;
}

.NewUsersPopupView__placeholders-accf4d {
  padding: 8px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/Popups/GetParametersManager/Popups/NewUsersPopup/NewUsersPopupView/NewUsersPopupView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".container {\n  height: 100%;\n  overflow-y: auto;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.placeholders {\n  padding: 8px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewUsersPopupView__container-b4698b`,
	"placeholders": `NewUsersPopupView__placeholders-accf4d`
};
module.exports = ___CSS_LOADER_EXPORT___;
